<template>
  <div
    class="form-group"
    :class="{ 'has-error': showError, 'has-helper': helper }"
  >
    <div class="col-lg-4">
      <label class="control-label"
        >{{ label }}<span v-if="required">*</span></label
      >
      <p class="help-block" v-if="helper">{{ helper }}</p>
    </div>
    <div class="col-md-8">
      <div class="input-group">
        <div class="input-group-btn">
          <button class="btn btn-danger" v-on:click.prevent="remove">
            <i class="material-icons">remove</i>
          </button>
        </div>
        <input
          type="text"
          readonly
          :value="value"
          class="form-control"
          :name="name"
        />
        <div class="input-group-btn">
          <button class="btn btn-primary" v-on:click.prevent="add">
            <i class="material-icons">add</i>
          </button>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
export default {
  props: {
    showError: Boolean,
    value: [String, Number],
    required: Boolean,
    label: String,
    name: String,
    helper: String
  },

  methods: {
    remove() {
      if (this.value > 0) {
        this.$emit('input', parseInt(this.value) - 1);
      }
    },

    add() {
      this.$emit('input', parseInt(this.value) + 1);
    }
  }
};
</script>
